import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import classNames from 'classnames'
import React from 'react'

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    container: {
      maxWidth: 60,
      display: 'flex',
      border: 'solid 1px #cfcfcf',
      borderRadius: 4,
      padding: '0px 2px',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    indicator: {
      width: 9,
      height: 16,
      margin: '2px 2px 2px 0px',
      borderRadius: 2,
    },
    redIndicator: {
      background: '#ff5a5a',
    },
    orangeIndicator: {
      background: '#ffb459',
    },
    greenIndicator: {
      background: '#61eacd',
    },
  })

interface IBatteryLevelIndicator extends WithStyles {
  batteryLevel?: number
}

const BatteryLevelIndicator = (props: IBatteryLevelIndicator) => {
  const { classes, batteryLevel = 0 } = props

  const renderBatteryLevel = () => {
    const nbIndicator = Math.ceil((batteryLevel * 100) / 20)
    const ret = []

    for (let i = 0; i < nbIndicator; i++) {
      ret.push(
        <div
          key={`color-${i}`}
          className={classNames(classes.indicator, {
            [classes.redIndicator]: nbIndicator === 1,
            [classes.orangeIndicator]: nbIndicator === 2,
            [classes.greenIndicator]: nbIndicator > 2,
          })}
        />
      )
    }

    for (let i = 0; i < 5 - nbIndicator; i++) {
      ret.push(<div key={`indicator-${i}`} className={classes.indicator} />)
    }

    return ret
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>{renderBatteryLevel()}</div>
    </div>
  )
}

export default withStyles(styles)(BatteryLevelIndicator)
